/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_User_DescriptionInputs */

const en_select_user_description = /** @type {(inputs: Select_User_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a user to configure their shipping preferences`)
};

const es_select_user_description = /** @type {(inputs: Select_User_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un usuario para configurar sus preferencias de envio`)
};

/**
* | output |
* | --- |
* | "Choose a user to configure their shipping preferences" |
*
* @param {Select_User_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_user_description = /** @type {((inputs?: Select_User_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_User_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_user_description(inputs)
	return es_select_user_description(inputs)
});